
import validator from 'validator';

const AddSurvey= (data) => {
    let errors = {};
    let url_regex = "((https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)";
    const { sTitle,link,sDate,eDate} = data;
    if (validator.isEmpty(sTitle)) {
        errors.sTitle = 'Enter Survey Title';
    }
    if (validator.isEmpty(link)) {
        errors.link = 'Enter Survey URL';
    }
    if (!validator.isURL(link)) {
        errors.link = 'Enter Valid URL';
    }
    if (!link.match(url_regex)) {
        errors.link = 'Enter Valid URL';
    }
    if (validator.isEmpty(sDate)) {
        errors.sDate = 'Enter start date';
    }
    if (validator.isEmpty(eDate)) {
        errors.eDate = 'Enter end date';
    }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default AddSurvey;
